import { useCallback, useEffect, useRef, useState } from 'react';

/** Copies text to the clipboard and reports `copied` for a moment afterwards. */
export function useCopyFeedback(durationMs = 1500) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number | null>(null);

  useEffect(() => () => {
    if (timer.current) window.clearTimeout(timer.current);
  }, []);

  const copy = useCallback(async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      if (timer.current) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setCopied(false), durationMs);
    } catch {
      // Clipboard access can fail in insecure contexts; copying is a convenience.
    }
  }, [durationMs]);

  return { copied, copy };
}
